'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ChartWrapper = require('components/ChartWrapper/ChartWrapper');

var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);

var _chart = require('helpers/chart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CoverageChart = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(CoverageChart, _PureComponent);

  function CoverageChart() {
    (0, _classCallCheck3.default)(this, CoverageChart);
    return (0, _possibleConstructorReturn3.default)(this, (CoverageChart.__proto__ || (0, _getPrototypeOf2.default)(CoverageChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(CoverageChart, [{
    key: 'getChartData',
    value: function getChartData() {
      var data = this.props.data;
      var t = this.context.t;

      if ((0, _isEmpty3.default)(data)) {
        return [];
      }

      return [[t('Stats'), t('Percents'), { role: 'annotation' }, { type: 'string', role: 'style' }], [t('Played'), data.played, data.played + '%', 'stroke-width: 100;'], [t('Downloaded'), data.downloads, data.downloads + '%', 'stroke-width: 100;']];
    }
  }, {
    key: 'getChartProps',
    value: function getChartProps() {
      var id = this.props.id;

      var data = this.getChartData();

      return {
        graphId: id,
        chartType: 'BarChart',
        data: data,
        options: {
          hAxis: {
            minValue: -1,
            baseline: -1,
            maxValue: 100,
            viewWindow: {
              max: 100,
              min: -1
            }
          },
          chartArea: {
            width: '65%',
            left: '20%'
          },
          tooltip: { isHtml: false },
          legend: {
            position: _chart.chartLegendPosition.none
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          className = _props.className;

      var loading = (0, _isEmpty3.default)(data);
      var chartProps = this.getChartProps();

      return _react2.default.createElement(_ChartWrapper2.default, {
        className: className,
        chartProps: chartProps,
        itemHeight: 25,
        showScale: true,
        loading: loading
      });
    }
  }]);
  return CoverageChart;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.object,
  id: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  data: {},
  id: 'coverageChart'
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
exports.default = CoverageChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/CoverageChart/CoverageChart.js
// module id = 2108
// module chunks = 1